import { post } from "@insite/client-framework/Services/ApiService";

export interface updateQuoteStatusProps {
    Status: string,
    QuoteId: string
}

export const updateQoutesStatus = async (paramaters: updateQuoteStatusProps) => {
    const response = await post<updateQuoteStatusProps>("/api/v2/Quote/UpdateStatus", paramaters);
    return response;
}